// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__31bYl","rootCenter":"LoadMoreObserver_rootCenter__1naar","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2-iQR"};